import React from 'react';

import { FormattedMessage } from 'react-intl';

import { RateShopper } from '../../../../../components/actionable-filter-pill/connected/shipping/rate-shopper';
import { SERVICE_COLLECTION } from '../../../../../filters/constants';
import { apiKey } from '../../../../../filters/options/service-collection';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: SERVICE_COLLECTION,
  displayName: <FormattedMessage {...messages.rateShopper} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: apiKey,
  expectsArgumentAsArray: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
  allowsMultipleSelection: true,
  actionableFilterPill: RateShopper,
};
